import { nextTick } from 'vue';
import { createI18n } from 'vue-i18n';
import { messageCompiler } from '@/shared/utils/messageCompiler';
import { DEFAULT_LOCALE, type Locale } from '@/shared/constants/locales';

const i18n = createI18n({
    legacy: false,
    locale: DEFAULT_LOCALE,
    messageCompiler,
});

export async function changeLocale(lang: Locale) {
    i18n.global.locale.value = lang;

    document.querySelector('html')?.setAttribute('lang', lang);

    const modules = import.meta.glob<Record<string, string>>(`../../i18n/*/*.json`, {
        eager: true
    });
    const regexLang = /\/i18n\/([^/]+)\//;
    const regexModule = /\/([^/]+)\.json$/;

    const messages = Object.fromEntries(
        Object.entries(modules)
            .filter(([path]) => regexLang.exec(path)?.[1] === lang)
            .map(([path, value]) => {
                const moduleName = regexModule.exec(path)?.[1] ?? path;
                return [moduleName, value] as const;
            })
    );

    i18n.global.setLocaleMessage(lang, messages);

    return nextTick();
}

export { i18n };
